import { useEffect, useState } from "react";
import axios from "axios";

const FRONTEND_VERSION = "5.2.7";
const API_URL = process.env.REACT_APP_API_URL + "version";

const VersionBanner = ({ variant = "inline" }) => {
    const [showBanner, setShowBanner] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [newVersion, setNewVersion] = useState("");

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await axios.get(API_URL);
                if (response.data.success && response.data.version !== FRONTEND_VERSION) {
                    setNewVersion(response.data.version);
                    setShowBanner(true);
                }
            } catch (error) {
                console.error("Failed to check version:", error);
            } finally {
                setIsLoading(false);
            }
        };

        checkVersion();
        const interval = setInterval(checkVersion, 5 * 60 * 1000); // Check every 5 minutes
        return () => clearInterval(interval);
    }, []);

    if (isLoading || !showBanner) return null;

    const classes = variant === "fixed" ? "fixed inset-x-0 top-0 z-50 bg-red-600 text-white text-center p-2 text-sm shadow" : "bg-red-600 text-white text-center px-2 py-1 text-xs rounded-md";

    return (
        <div className={classes}>
            ⚠️ New version available: {newVersion} (Current: {FRONTEND_VERSION}). Please refresh your browser to update.
        </div>
    );
};

export { VersionBanner, FRONTEND_VERSION };
